import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
})

export class DurationPipe implements PipeTransform {

  transform(value: any): any {

    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value - 60 * minutes);
    const secondsString = seconds < 10 ? '0' + seconds : seconds;

    const countDown = secondsString

    return minutes+ ":" + secondsString;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/video-player/duration.pipe.ts